<template>
  <div>
    <b-modal id="modalEditDynamicShapingSettings" ref="modalEditDynamicShapingSettings" :title="$t('Dynamic shaping')" hide-footer size="lg" @shown="shown">
      <div v-if="editItem">
        <b-tabs pills card>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.service_id" :options="services" :disabled="editItem.isEdit"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Apply to VPN IP')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="isVPN"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Apply to non-VPN IP')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="isNonVPN"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Incoming')">
            <b-form-group>
              <b-button size="sm" class="mt-2" variant="success" @click="showAddIncomingTimeRange">{{ $t('Add time range') }}</b-button>
              <b-button size="sm" class="mt-2" variant="success" @click="showAddIncomingBorder">{{ $t('Add border') }}</b-button>
            </b-form-group>

            <b-row>
              <b-col id="grayBorder">
                {{ $t('Border') }}
              </b-col>
              <b-col id="grayBorder" v-for="item in incomingTimeRange" :key="item.id">
                <b-row>
                  <b-col cols="7" >
                    {{ item.nameTimeRange }}
                  </b-col>
                  <b-col cols="5" style="padding-left:0px;padding-right:0px;">
                    <b-button size="sm" id="transparent" @click="deleteIncomingTimeRange(item)">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col id="grayBorder">
                {{ $t('Accaunt state') }}
              </b-col>
              <b-col id="grayBorder">
              </b-col>
            </b-row>
            <b-row v-for="item in incomingShapng" :key="item.border">
              <b-col id="grayBorder">
                {{ item.border + 'b' }}
              </b-col>
              <b-col id="grayBorder" v-for="itemd in item.timeRange" :key="itemd.timerange">
                <b-form-input v-model="itemd.limit"/>
              </b-col>
              <b-col id="grayBorder">
                <b-form-select v-model="item.account_state" :options="accountState"/>
              </b-col>
              <b-col id="grayBorder">
                <b-button size="sm" id="transparent" @click="deleteIncomingShaping(item)">
                  <b-img :src='deleteImage'/>
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col style="margin:5px">
                <b-input-group>
                  <b-form-select v-model="selectIncomingTariffClasses" :options="incomingTariffClasses"/>
                  <b-input-group-append>
                    <b-button @click="addIncomingTariffClasses">{{ $t('Add') }}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table striped hover small
              :items="incomingTrafficClassesItems"
              :fields="incomingTrafficClassesFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="deleteIncomingTrafficClasses(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Outgoing')">
            <b-form-group>
              <b-button size="sm" class="mt-2" variant="success" @click="showAddOutgoingTimeRange">{{ $t('Add time range') }}</b-button>
              <b-button size="sm" class="mt-2" variant="success" @click="showAddOutgoingBorder">{{ $t('Add border') }}</b-button>
            </b-form-group>
            <b-row>
              <b-col id="grayBorder">
                {{ $t('Border') }}
              </b-col>
              <b-col id="grayBorder" v-for="item in outgoingTimeRange" :key="item.id">
                <b-row>
                  <b-col cols="7" >
                    {{ item.nameTimeRange }}
                  </b-col>
                  <b-col cols="5" style="padding-left:0px;padding-right:0px;">
                    <b-button size="sm" id="transparent" @click="deleteOutgoingTimeRange(item)">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col id="grayBorder">
                {{ $t('Accaunt state') }}
              </b-col>
              <b-col id="grayBorder">
              </b-col>
            </b-row>
            <b-row v-for="item in outgoingShapng" :key="item.border">
              <b-col id="grayBorder">
                {{ item.border + 'b' }}
              </b-col>
              <b-col id="grayBorder" v-for="itemd in item.timeRange" :key="itemd.timerange">
                <b-form-input v-model="itemd.limit"/>
              </b-col>
              <b-col id="grayBorder">
                <b-form-select v-model="item.account_state" :options="accountState"/>
              </b-col>
              <b-col id="grayBorder">
                <b-button size="sm" id="transparent" @click="deleteOutgoingShaping(item)">
                  <b-img :src='deleteImage'/>
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col style="margin:5px">
                <b-input-group>
                  <b-form-select v-model="selectOutgoingTariffClasses" :options="outgoingTariffClasses"/>
                  <b-input-group-append>
                    <b-button @click="addOutgoingTariffClasses">{{ $t('Add') }}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table striped hover small
              :items="outgoingTrafficClassesItems"
              :fields="outgoingTrafficClassesFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="deleteOutgoingTrafficClasses(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Turbo mode')">
            <b-row>
              <b-col style="margin:5px">
                <b-button variant="success" @click="swohTurboMode">{{ $t('Add') }}</b-button>
              </b-col>
            </b-row>
            <b-table striped hover small
              :items="turboModeItems"
              :fields="turboModeFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="editTurboMode(row)" id="transparent">
                  <b-img :src='editImage'/>
                </b-button>
                <b-button size="sm" @click.stop="deleteTurboMode(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('RADIUS parameters')">
            <b-row>
              <b-col style="margin:5px">
                <b-button variant="success" @click="swohRadiusAttr">{{ $t('Add') }}</b-button>
              </b-col>
            </b-row>
            <b-table striped hover small
              :items="radiusAttrItems"
              :fields="radiusAttrFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="editRadiusAttr(row)" id="transparent">
                  <b-img :src='editImage'/>
                </b-button>
                <b-button size="sm" @click.stop="deleteRadiusAttr(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditDynamicShapingSettings.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange" size="lg">
      <b-table striped hover
      :items="timeRangeList"
      :fields="timeRangeFields"
      selectable
      select-mode="single"
      @row-clicked="rowClickTimeRange">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addTimeRange">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTimeRange.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal hide-footer ref="modalBorder">
      <b-form-group :label="$t('Border')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="border"/>
      </b-form-group>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addBorder">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalBorder.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <turboMode :editTurboMode="selectedTurboMode" :turboModeItems="turboModeItems"/>
    <radiusAttr :editRadiusAttr="selectedRadiusAttr" :radiusAttrItems="radiusAttrItems"/>

  </div>
</template>

<script>
import turboMode from './turboMode'
import radiusAttr from './radiusAttr'

export default {
  components: {
    turboMode,
    radiusAttr
  },
  props: {
    editItem: null
  },
  data () {
    return {
      isIncomingBorder: false,
      isOutgoingBorder: false,
      border: '',
      isOutgoingTimeRange: false,
      isIncomingTimeRange: false,
      rowTimeRange: null,
      incomingTimeRange: [],
      incomingShapng: [],
      outgoingTimeRange: [],
      outgoingShapng: [],
      selectIncomingTariffClasses: 0,
      incomingTrafficClassesItems: [],
      incomingTrafficClassesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectOutgoingTariffClasses: 0,
      outgoingTrafficClassesItems: [],
      outgoingTrafficClassesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTurboMode: {
        incoming_rate: '',
        outgoing_rate: '',
        name: ''
      },
      turboModeItems: [],
      turboModeFields: [
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'speed', label: this.$i18n.t('Speed'), sortable: true},
        {key: 'price', label: this.$i18n.t('Price'), sortable: true},
        {key: 'work', label: this.$i18n.t('Work until'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedRadiusAttr: {
        rad_vendor: '',
        rad_attr: '',
        isEdit: false,
        value: '',
        rad_type: 1
      },
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'rad_vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'rad_attr', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'type', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      accountState: [
        {value: 0, text: this.$i18n.t('Not used')},
        {value: 1, text: this.$i18n.t('System blocking')},
        {value: 2, text: this.$i18n.t('Admin blocking')},
        {value: 3, text: this.$i18n.t('User blocking')}
      ],
      timeRangeFields: [
        {key: 'tr_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Name'), sortable: true},
        {key: 'range', label: this.$i18n.t('Range'), sortable: true},
        {key: 'priority', label: this.$i18n.t('Priority'), sortable: true}
      ],
      deleteImage: require('@/assets/img/document_delete.png'),
      editImage: require('@/assets/img/document_edit.png'),
      selectShaping: null,
      isVPN: false,
      isNonVPN: false
    }
  },
  methods: {
    save () {
      if (!this.editItem.service_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      if (!this.incomingShapng.length || !this.incomingTimeRange.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incoming table is empty'), 'Error')
        return
      }
      if (!this.outgoingShapng.length || !this.outgoingTimeRange.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Outgoing table is empty'), 'Error')
        return
      }
      if (!this.incomingTrafficClassesItems.length || !this.outgoingTrafficClassesItems.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Time range table is empty'), 'Error')
        return
      }
      let isValidation = true
      for (let el of this.incomingShapng) {
        for (let elShapng of el.timeRange) {
          if (!elShapng.limit.length || elShapng.limit === '0') {
            isValidation = false
          }
          if (isNaN(elShapng.limit)) {
            let valS = elShapng.limit.charAt(0)
            if (valS === 's') {
              let isNum = elShapng.limit.slice(1)
              if (isNaN(isNum) || !isNum.length || isNum === '0') {
                isValidation = false
              }
            } else {
              isValidation = false
            }
          }
        }
      }
      for (let el of this.outgoingShapng) {
        for (let elShapng of el.timeRange) {
          if (!elShapng.limit.length) {
            isValidation = false
          }
          if (isNaN(elShapng.limit || elShapng.limit === '0')) {
            let valS = elShapng.limit.charAt(0)
            if (valS === 's') {
              let isNum = elShapng.limit.slice(1)
              if (isNaN(isNum) || !isNum.length || isNum === '0') {
                isValidation = false
              }
            } else {
              isValidation = false
            }
          }
        }
      }
      if (!isValidation) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Values must be integer or start from \'s\''), 'Error')
        return
      }

      let tmpDynamicShaping = {
        'service_id': 0,
        'flags': 0,
        'attrs': [],
        'turbo_mode_settings': [],
        'ingress': {
          'tclass_ids': [],
          'cost_table': []
        },
        'egress': {
          'tclass_ids': [],
          'cost_table': []
        }
      }
      tmpDynamicShaping.service_id = this.editItem.service_id
      if (this.isVPN && this.isNonVPN) {
        tmpDynamicShaping.flags = 3
      } else if (!this.isVPN && this.isNonVPN) {
        tmpDynamicShaping.flags = 2
      } else if (this.isVPN && !this.isNonVPN) {
        tmpDynamicShaping.flags = 1
      } else if (!this.isVPN && !this.isNonVPN) {
        tmpDynamicShaping.flags = 0
      }
      tmpDynamicShaping.turbo_mode_settings = this.turboModeItems
      tmpDynamicShaping.attrs = this.radiusAttrItems
      for (let el of this.incomingTrafficClassesItems) {
        tmpDynamicShaping.ingress.tclass_ids.push(el.id)
      }
      for (let el of this.outgoingTrafficClassesItems) {
        tmpDynamicShaping.egress.tclass_ids.push(el.id)
      }
      for (let el of this.incomingShapng) {
        for (let elTR of el.timeRange) {
          let newEl = {
            account_state: 0,
            border: 0,
            time_range: 0,
            limit: ''
          }
          newEl.account_state = el.account_state
          newEl.border = el.border
          newEl.time_range = elTR.timerange
          newEl.limit = elTR.limit
          tmpDynamicShaping.ingress.cost_table.push(newEl)
        }
      }
      for (let el of this.outgoingShapng) {
        for (let elTR of el.timeRange) {
          let newEl = {
            account_state: 0,
            border: 0,
            time_range: 0,
            limit: ''
          }
          newEl.account_state = el.account_state
          newEl.border = el.border
          newEl.time_range = elTR.timerange
          newEl.limit = elTR.limit
          tmpDynamicShaping.egress.cost_table.push(newEl)
        }
      }
      let response = this.editItem.isEdit
        ? this.$store.dispatch('Settings/UPDATE_DYNAMIC_SHAPING', tmpDynamicShaping)
        : this.$store.dispatch('Settings/CREATE_DYNAMIC_SHAPING', tmpDynamicShaping)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DYNAMIC_SHAPING_SERVICES')
          this.$refs.modalEditDynamicShapingSettings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    async shown () {
      this.outgoingShapng = []
      this.incomingShapng = []
      this.outgoingTimeRange = []
      this.incomingTimeRange = []
      this.outgoingTrafficClassesItems = []
      this.incomingTrafficClassesItems = []
      this.selectShaping = {}
      this.turboModeItems = []
      this.radiusAttrItems = []
      if (this.editItem.isEdit) {
        this.$store.dispatch('Settings/GET_DYNAMIC_SHAPING', this.editItem.service_id)
        this.selectShaping = JSON.parse(JSON.stringify(this.$store.getters['Settings/DYNAMIC_SHAPING']))
        this.editItem.flags = this.selectShaping.flags
        this.turboModeItems = this.selectShaping.turbo_mode_settings
        for (let el of this.selectShaping.ingress_egress[0].shaping) {
          if (el.border === this.selectShaping.ingress_egress[0].shaping[0].border) {
            let newEl = {
              nameTimeRange: '',
              id: 0
            }
            newEl.id = el.timerange
            this.incomingTimeRange.push(newEl)
          }
        }
        for (let el of this.incomingTimeRange) {
          for (let elTimeRange of this.timeRangeList) {
            if (el.id === elTimeRange.tr_id) {
              el.nameTimeRange = elTimeRange.name + '(' + el.id + ')'
            }
          }
        }
        let incomingShapng = JSON.parse(JSON.stringify(this.selectShaping.ingress_egress[0].shaping))
        let incomingUniq = []
        for (let el of incomingShapng) {
          incomingUniq.push(el.border)
        }
        incomingUniq = Array.from(new Set(incomingUniq))
        for (let el of incomingUniq) {
          let newEl = {
            border: 0,
            account_state: 0,
            timeRange: []
          }
          newEl.border = el
          for (let elAccountState of incomingShapng) {
            if (elAccountState.border === el) {
              newEl.account_state = elAccountState.account_state
            }
          }
          this.incomingShapng.push(newEl)
        }
        for (let el of incomingShapng) {
          if (el.border === incomingUniq[0]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[0].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[1]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[1].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[2]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[2].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[3]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[3].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[4]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[4].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[5]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[5].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[6]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[6].timeRange.push(newEl)
          }
          if (el.border === incomingUniq[7]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.incomingShapng[7].timeRange.push(newEl)
          }
        }
        for (let el of this.selectShaping.ingress_egress[1].shaping) {
          if (el.border === this.selectShaping.ingress_egress[1].shaping[0].border) {
            let newEl = {
              nameTimeRange: '',
              id: 0
            }
            newEl.id = el.timerange
            this.outgoingTimeRange.push(newEl)
          }
        }
        for (let el of this.outgoingTimeRange) {
          for (let elTimeRange of this.timeRangeList) {
            if (el.id === elTimeRange.tr_id) {
              el.nameTimeRange = elTimeRange.name + '(' + el.id + ')'
            }
          }
        }
        let outgoingShapng = JSON.parse(JSON.stringify(this.selectShaping.ingress_egress[1].shaping))
        let outgoingUniq = []
        for (let el of outgoingShapng) {
          outgoingUniq.push(el.border)
        }
        outgoingUniq = Array.from(new Set(outgoingUniq))
        for (let el of outgoingUniq) {
          let newEl = {
            border: 0,
            account_state: 0,
            timeRange: []
          }
          newEl.border = el
          for (let elAccountState of outgoingShapng) {
            if (elAccountState.border === el) {
              newEl.account_state = elAccountState.account_state
            }
          }
          this.outgoingShapng.push(newEl)
        }
        for (let el of outgoingShapng) {
          if (el.border === outgoingUniq[0]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[0].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[1]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[1].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[2]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[2].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[3]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[3].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[4]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[4].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[5]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[5].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[6]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[6].timeRange.push(newEl)
          }
          if (el.border === outgoingUniq[7]) {
            let newEl = {
              limit: '',
              timerange: 0
            }
            newEl.limit = el.limit
            newEl.timerange = el.timerange
            this.outgoingShapng[7].timeRange.push(newEl)
          }
        }

        let incomingTrafficClassesItems = []
        incomingTrafficClassesItems = this.selectShaping.ingress_egress[0].tclass
        for (let el of incomingTrafficClassesItems) {
          for (let elTcClass of this.realTrafficClasses) {
            if (el === elTcClass.tclass_id) {
              let newEl = {
                id: 0,
                name: ''
              }
              newEl.id = elTcClass.tclass_id
              newEl.name = elTcClass.name
              this.incomingTrafficClassesItems.push(newEl)
            }
          }
        }
        let outgoingTrafficClassesItems = []
        outgoingTrafficClassesItems = this.selectShaping.ingress_egress[1].tclass
        for (let el of outgoingTrafficClassesItems) {
          for (let elTcClass of this.realTrafficClasses) {
            if (el === elTcClass.tclass_id) {
              let newEl = {
                id: 0,
                name: ''
              }
              newEl.id = elTcClass.tclass_id
              newEl.name = elTcClass.name
              this.outgoingTrafficClassesItems.push(newEl)
            }
          }
        }
        for (let el of this.turboModeItems) {
          await this.$store.dispatch('Tariffing/GET_ONE_TIME_SERVICE', el.once_service_id).then(response => {
            let once = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ONE_TIME_SERVICE']))
            el.price = once.once_service_data.cost
          })
          if (el.incoming_limit || el.outgoing_limit) {
            if (el.incoming_limit && el.outgoing_limit) {
              el.work = el.incoming_limit + 'B/' + el.outgoing_limit + 'B'
            } else if (el.incoming_limit) {
              el.work = el.incoming_limit + 'B/' + this.$i18n.t('not set')
            } else if (el.outgoing_limit) {
              el.work = this.$i18n.t('not set') + '/' + el.outgoing_limit + 'B'
            }
          } else {
            if (el.till_acct_period_end) {
              el.work = this.$i18n.t('until aggregation period end')
            } else {
              let d = Math.floor(el.duration / 86400)
              let h = Math.floor((el.duration - d * 86400) / 3600)
              let m = Math.floor((el.duration - (d * 86400) - (h * 3600)) / 60)
              el.work = d + this.$i18n.t('d. ') + h + this.$i18n.t('h. ') + m + this.$i18n.t('m.')
            }
          }
          let speedIncoming = el.incoming_rate
          let speedOutgoing = el.outgoing_rate
          if (speedIncoming === '0') {
            speedIncoming = this.$i18n.t('Disabled')
          } else if (speedIncoming === '-1') {
            speedIncoming = this.$i18n.t('Unlimited')
          }
          if (speedOutgoing === '0') {
            speedOutgoing = this.$i18n.t('Disabled')
          } else if (speedOutgoing === '-1') {
            speedOutgoing = this.$i18n.t('Unlimited')
          }
          el.speed = speedIncoming + '/' + speedOutgoing
        }

        this.radiusAttrItems = this.selectShaping.radius_attrs
        for (let el of this.radiusAttrItems) {
          switch (el.rad_type) {
            case 1:
              this.$set(el, 'type', this.$i18n.t('String'))
              break
            case 2:
              this.$set(el, 'type', this.$i18n.t('Number'))
              break
            case 3:
              this.$set(el, 'type', this.$i18n.t('Binary'))
              break
          }
        }
      }
      switch (this.editItem.flags) {
        case 0 :
          this.isVPN = false
          this.isNonVPN = false
          break
        case 1 :
          this.isVPN = true
          this.isNonVPN = false
          break
        case 2 :
          this.isVPN = false
          this.isNonVPN = true
          break
        case 3 :
          this.isVPN = true
          this.isNonVPN = true
          break
      }
    },
    swohTurboMode () {
      this.selectedTurboMode = {
        settings_id: 0,
        incoming_limit: 0,
        isEdit: false,
        incoming_rate: '',
        name: '',
        once_service_id: 0,
        outgoing_limit: 0,
        outgoing_rate: '',
        price: 0,
        till_acct_period_end: 0
      }
      this.$root.$emit('bv::show::modal', 'modalTurboModeDynamicShaping', '#btnShow')
    },
    editTurboMode (row) {
      this.selectedTurboMode = row.item
      this.selectedTurboMode.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalTurboModeDynamicShaping', '#btnShow')
    },
    deleteTurboMode (row) {
      this.turboModeItems = this.turboModeItems.filter((value) => {
        return value !== row.item
      })
    },
    swohRadiusAttr () {
      this.selectedRadiusAttr = {
        rad_vendor: '',
        rad_attr: '',
        isEdit: false,
        value: '',
        rad_type: 1
      }
      this.$root.$emit('bv::show::modal', 'modalRadiusAttrDynamicShaping', '#btnShow')
    },
    editRadiusAttr (row) {
      this.selectedRadiusAttr = row.item
      this.selectedRadiusAttr.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalRadiusAttrDynamicShaping', '#btnShow')
    },
    deleteRadiusAttr (row) {
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== row.item
      })
    },
    addIncomingTariffClasses () {
      for (let el of this.incomingTrafficClassesItems) {
        if (el.id === this.selectIncomingTariffClasses) {
          return
        }
      }
      for (let elTariffClass of this.realTrafficClasses) {
        if (elTariffClass.tclass_id === this.selectIncomingTariffClasses) {
          let newEl = {
            id: 0,
            name: ''
          }
          newEl.id = elTariffClass.tclass_id
          newEl.name = elTariffClass.name
          this.incomingTrafficClassesItems.push(newEl)
        }
      }
    },
    deleteIncomingTrafficClasses (row) {
      this.incomingTrafficClassesItems = this.incomingTrafficClassesItems.filter((value) => {
        return value !== row.item
      })
    },
    addOutgoingTariffClasses () {
      for (let el of this.outgoingTrafficClassesItems) {
        if (el.id === this.selectOutgoingTariffClasses) {
          return
        }
      }
      for (let elTariffClass of this.realTrafficClasses) {
        if (elTariffClass.tclass_id === this.selectOutgoingTariffClasses) {
          let newEl = {
            id: 0,
            name: ''
          }
          newEl.id = elTariffClass.tclass_id
          newEl.name = elTariffClass.name
          this.outgoingTrafficClassesItems.push(newEl)
        }
      }
    },
    deleteOutgoingTrafficClasses (row) {
      this.outgoingTrafficClassesItems = this.outgoingTrafficClassesItems.filter((value) => {
        return value !== row.item
      })
    },
    deleteIncomingTimeRange (item) {
      this.incomingTimeRange = this.incomingTimeRange.filter((value) => {
        return value.id !== item.id
      })
      for (let el of this.incomingShapng) {
        el.timeRange = el.timeRange.filter((value) => {
          return value.timerange !== item.id
        })
      }
    },
    deleteOutgoingTimeRange (item) {
      this.outgoingTimeRange = this.outgoingTimeRange.filter((value) => {
        return value.id !== item.id
      })
      for (let el of this.outgoingShapng) {
        el.timeRange = el.timeRange.filter((value) => {
          return value.timerange !== item.id
        })
      }
    },
    deleteOutgoingShaping (item) {
      this.outgoingShapng = this.outgoingShapng.filter((value) => {
        return value.border !== item.border
      })
    },
    deleteIncomingShaping (item) {
      this.incomingShapng = this.incomingShapng.filter((value) => {
        return value.border !== item.border
      })
    },
    showAddIncomingTimeRange () {
      this.isIncomingTimeRange = true
      this.isOutgoingTimeRange = false
      this.rowTimeRange = null
      this.$refs.modalTimeRange.show()
    },
    showAddOutgoingTimeRange () {
      this.isIncomingTimeRange = false
      this.isOutgoingTimeRange = true
      this.rowTimeRange = null
      this.$refs.modalTimeRange.show()
    },
    rowClickTimeRange (row) {
      this.rowTimeRange = row
    },
    addTimeRange () {
      if (!this.rowTimeRange) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select time range'), 'Error')
        return
      }
      if (this.isIncomingTimeRange) {
        for (let el of this.incomingTimeRange) {
          if (el.id === this.rowTimeRange.tr_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
            return
          }
        }
      }
      if (this.isOutgoingTimeRange) {
        for (let el of this.outgoingTimeRange) {
          if (el.id === this.rowTimeRange.tr_id) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
            return
          }
        }
      }
      this.rowTimeRange.limit = ''
      this.rowTimeRange.timerange = this.rowTimeRange.tr_id
      this.rowTimeRange.nameTimeRange = this.rowTimeRange.name + '(' + this.rowTimeRange.tr_id + ')'
      this.rowTimeRange.id = this.rowTimeRange.tr_id
      if (this.isIncomingTimeRange) {
        this.incomingTimeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
        for (let el of this.incomingShapng) {
          el.timeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
          this.$set(el.timeRange, 'limit', el.timeRange)
        }
      }
      if (this.isOutgoingTimeRange) {
        this.outgoingTimeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
        for (let el of this.outgoingShapng) {
          el.timeRange.push(JSON.parse(JSON.stringify(this.rowTimeRange)))
          this.$set(el.timeRange, 'limit', el.timeRange)
        }
      }

      this.$refs.modalTimeRange.hide()
    },
    showAddIncomingBorder () {
      this.border = ''
      this.isIncomingBorder = true
      this.isOutgoingBorder = false
      this.$refs.modalBorder.show()
    },
    showAddOutgoingBorder () {
      this.border = ''
      this.isIncomingBorder = false
      this.isOutgoingBorder = true
      this.$refs.modalBorder.show()
    },
    addBorder () {
      if (!this.border) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Border fields is invalid'), 'Error')
        return
      }
      let newEl = {
        border: 0,
        account_state: 0,
        timeRange: []
      }
      if (this.isIncomingBorder) {
        newEl.border = Number(this.border)
        newEl.timeRange = JSON.parse(JSON.stringify(this.incomingTimeRange))
        this.incomingShapng.push(newEl)
      }
      if (this.isOutgoingBorder) {
        newEl.border = Number(this.border)
        newEl.timeRange = JSON.parse(JSON.stringify(this.outgoingTimeRange))
        this.outgoingShapng.push(newEl)
      }
      this.$refs.modalBorder.hide()
    }
  },
  computed: {
    services () {
      let services = []
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))) {
        if (el.service_type === 3 && (el.service_id !== el.parent_id)) {
          let newEl = {
            value: 0,
            text: ''
          }
          newEl.value = el.service_id
          newEl.text = el.service_name + '(' + el.service_id + ')'
          services.push(newEl)
        }
      }
      if (!this.editItem.isEdit) {
        for (let elDel of JSON.parse(JSON.stringify(this.$store.getters['Settings/DYNAMIC_SHAPING_SERVICES']))) {
          services = services.filter(function (el) {
            return el.value !== elDel.service_id
          })
        }
      }
      return services
    },
    realTrafficClasses () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TRAFFIC_CLASSES_LIST']))
    },
    timeRangeList () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TIME_RANGE']))
    },
    incomingTariffClasses () {
      let res = []
      for (let el of this.realTrafficClasses) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.tclass_id
        newEl.text = el.name + '(' + el.tclass_id + ')'
        res.push(newEl)
      }
      return res
    },
    outgoingTariffClasses () {
      let res = []
      for (let el of this.realTrafficClasses) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.tclass_id
        newEl.text = el.name + '(' + el.tclass_id + ')'
        res.push(newEl)
      }
      return res
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/dynamicShaping/editModal.vue